import React, { useEffect } from "react";
import "./styles/App.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Exam from "./pages/exam";
import { MatchingHeadingsProvider } from "./context/MatchingHeadingsContext";
import { ExamProvider, useExam } from "./context/ExamContext";
import { ToastContainer } from "react-toastify";
import { UserProvider, useUser } from "./context/userContext";
import { FontSizeProvider } from "./context/FontSizeContext";
import { ThemeProvider } from "./context/ThemeContext";
import { ConnectionProvider } from "./context/ConnectionContext";
import { SavingProvider } from "./context/SavingContext";
import NotAuthenticated from "./components/layout/NotAuthenticated";
import Loading from "./components/layout/Loading";
import "react-toastify/dist/ReactToastify.css";
import PCOnlyWrapper from "./components/layout/PcOnlyWarning";
import { examUrlParams } from "./utils/urlParams";

const queryClient = new QueryClient();

// Stale data clearing is handled by bootstrap.js (imported in index.js)
// before any React component mounts. No cleanup logic needed here.

function App() {
  return (
    <PCOnlyWrapper>
      <UserProvider>
        <ExamProvider>
          <UserContent />
        </ExamProvider>
      </UserProvider>
    </PCOnlyWrapper>
  );
}

function UserContent() {
  const { user, loading } = useUser();
  const {
    isDemoExam,
    setDemoExamData,
    setUprIdData,
    setProductIdData,
    setProductTypeData,
  } = useExam();

  const {
    isDemoExam: isDemoExamParam,
    productType,
    productId,
    uprId,
  } = examUrlParams;

  useEffect(() => {
    setDemoExamData(isDemoExamParam);
    setProductTypeData(productType);
    setProductIdData(productId);
    setUprIdData(uprId);
  }, []);

  if (loading) return <Loading />;
  const isAllowed =
    (isDemoExamParam && user == null) || (!isDemoExam && !loading && user);

  return (
    <ConnectionProvider>
      <QueryClientProvider client={queryClient}>
        <MatchingHeadingsProvider>
          <FontSizeProvider>
            <SavingProvider>
              <ThemeProvider>
                {isAllowed ? (
                  <>
                    {/* <PreventBrowserActions /> */}
                    {/* <Header /> */}
                    <Exam />
                    <ToastContainer />
                  </>
                ) : (
                  <NotAuthenticated />
                )}
              </ThemeProvider>
            </SavingProvider>
          </FontSizeProvider>
        </MatchingHeadingsProvider>
      </QueryClientProvider>
    </ConnectionProvider>
  );
}

export default App;
